import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import MedusaLipPiercingImage from '../../Assets/Piercing Services/medusa lip piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function MedusaLipPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Medusa Lip Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Medusa Lip Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Medusa Lip Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={MedusaLipPiercingImage} alt="Medusa Lip Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Medusa Lip Piercing</h3>

          <p>
            Enhance your facial style with our professional Medusa lip piercing services in the UAE, available at an affordable price of 200 AED. Medusa lip piercing is a stylish and elegant piercing located in the center of the upper lip, just above the cupid’s bow, making it a perfect choice for those who want a refined yet eye-catching look. Often adorned with a sleek stud or gemstone, this piercing highlights the natural shape of your lips and adds a touch of sophistication to your overall appearance. Its central placement creates a balanced and symmetrical aesthetic, making it one of the most popular choices among modern facial piercings.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each Medusa lip piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Lip piercings require expert handling due to the sensitivity of the area, and our experienced specialists use advanced techniques to reduce discomfort and ensure a quick and efficient experience.
          </p>

          <p>
            Medusa lip piercing is ideal for individuals who want to enhance their facial features with a stylish and noticeable yet elegant piercing. Its placement draws attention to the lips and complements various face shapes, making it suitable for both subtle and bold styles. It can be worn as a standalone statement piece or paired with other piercings such as lower lip or nose piercings for a more defined and personalized look. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options to match your style and comfort.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient for clients with busy schedules. We provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that facial piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your Medusa lip piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our Medusa lip piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted Medusa lip piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a stylish and elegant look effortlessly. Book your Medusa lip piercing appointment today and elevate your appearance with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Medusa Lip Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MedusaLipPiercing;